import Swiper from 'swiper';
import { Autoplay, Grid, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';

document.querySelectorAll('.swiper-header').forEach((swiperEl) => {
    const next = swiperEl.parentNode.querySelector('.btn-next');
    const prev = swiperEl.parentNode.querySelector('.btn-prev');

    new Swiper(swiperEl, {
        modules: [Autoplay, Navigation],

        loop: true,

        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
    });
});

document.querySelectorAll('.swiper-logos').forEach((swiperEl) => {
    const pagination = swiperEl.parentNode.querySelector('.swiper-logos-pagination');

    new Swiper(swiperEl, {
        modules: [Autoplay, Pagination],

        grabCursor: true,
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 12,

        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        pagination: {
            clickable: true,
            el: pagination,
        },

        breakpoints: {
            1440: {
                slidesPerGroup: 5,
                slidesPerView: 5,
                spaceBetween: 48,
            },
            1200: {
                slidesPerGroup: 5,
                slidesPerView: 5,
                spaceBetween: 24,
            },
            984: {
                slidesPerGroup: 4,
                slidesPerView: 4,
                spaceBetween: 24,
            },
            768: {
                slidesPerGroup: 4,
                slidesPerView: 4,
                spaceBetween: 12,
            },
            576: {
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 12,
            },
        },
    });
});

document.querySelectorAll('.swiper-pictogrammes').forEach((swiperEl) => {
    const pagination = swiperEl.parentNode.querySelector('.swiper-pictogrammes-pagination');

    new Swiper('.swiper-pictogrammes', {
        modules: [Autoplay, Grid, Pagination],

        grabCursor: true,
        slidesPerView: 2,
        spaceBetween: 12,

        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            stopOnLastSlide: false,
        },
        pagination: {
            clickable: true,
            el: pagination,
        },

        breakpoints: { // breakpoints basés sur la largeur des svg présents dans le slider et non pas sur bootstrap
            984: {
                grid: {
                    fill: 'row',
                    rows: 2,
                },
                slidesPerView: 5,
                spaceBetween: 48,
            },
            800: {
                grid: {
                    fill: 'row',
                    rows: 1,
                },
                slidesPerView: 5,
                spaceBetween: 24,
            },
            640: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
            480: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
    });
});